<template>
  <div v-if="status =='STATUS_EFFECTIVENESS'" class="container" :class="{'section-loading': effectivLoading}">
    <h3 class="text-green m-0">【{{ message_data.devfilter_name }}】</h3>
    
    <table class="table table-basic mt-4 mb-4">
      <thead>
        <tr>
          <th>發佈日期</th>
          <td>{{ message_data.upload_date | dateFormat }}</td>
          <th>下架日期</th>
          <td>{{ message_data.end_date | dateFormat }}</td>
        </tr>
        <tr>
          <th>申請者</th>
          <td>{{ message_data.agnt_name }}</td>
          <th>申請日期</th>
          <td>{{ message_data.applydate | dateFormat }}</td>
        </tr>
        <tr>
          <th>最後編輯者</th>
          <td>{{ message_data.agnt_name }}</td>
          <th>最後編輯時間</th>
          <td>{{ message_data.modifydate | dateFormat }}</td>
        </tr>
        
      </thead>
    </table>
    
    <div class="breadcrumb row" >
      <label class="col-1 text-right">路徑</label>
      <div class="col-11">
        <ul class="breadcrumb-list">
          <li class="bread"
          :class="{'active': bread.index === currentTableIndex}"
          v-for="(bread, i) in breadcrumbs"
          :key="`effect-bread-${i}`">
            <a v-if="bread.index === currentTableIndex" role="button">{{bread.name}}</a>
            <a v-else role="button" @click="returnTable(bread, i)">{{bread.name}}</a>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="permission == true">
      <table v-if="tableRow && tableRow.length && !isBottom" class="table datatable insurance-green">
        <thead>
            <tr>
              <th class="text-center">業務系統</th>
              <th class="text-center">業務員數</th>
              <th class="text-center">使用率</th>
            </tr>
        </thead>
        <tbody>
          <tr v-for="(row, rid) in tableRow"
          :key="`effe-row-${rid}`">
            <td v-if="row.ta_count && row.ta_count > 0" class="text-center">
              <a class="link text-underline" @click="gotoNext(row)">{{row.cedvnm}}</a>
            </td>
            <td v-else class="text-center">
              <a class="text">{{row.cedvnm}}</a>
            </td>
            <td class="text-center">{{ row.ta_count ? row.ta_count : '0' }}</td>
            <td class="text-center">{{ row.click_percentage ? row.click_percentage : '0' }}%</td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="bg-white">
            <th class="text-center">合計</th>
            <th class="text-center">{{ sumAngtCount(tableRow) }}</th>
            <th class="text-center">{{ sumUsedCount(tableRow) }}%</th>
          </tr>
        </tfoot>
      </table>
      <table v-else-if="tableRow && tableRow.length" class="table datatable insurance-green">
        <thead>
            <tr>
              <th class="text-center">序號</th>
              <th class="text-center">單位代號</th>
              <th class="text-center">姓名</th>
              <th class="text-center">使用</th>
            </tr>
        </thead>
        <tbody>
          <tr v-for="(row, rid) in tableRow[0].click_agnt_list"
          :key="`effe-row-${rid}`">
            <td class="text-center">
              <span>{{ rid + 1 }}</span>
            </td>
            <td class="text-center">{{ row.div_no }}</td>
            <td class="text-center">{{ row.name }}</td>
            <td class="text-center">
              <i v-if="row.is_click" class="icon-check mr-2 font-weight-bold"></i>
              <i v-else class="icon-close mr-2 text-danger font-weight-bold"></i>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else class="empty-block w-100" >
        <span>無符合條件名單。</span>
      </div>
      <p>使用率=業務員點擊人數/業務員人數</p>
    </div>
    <div v-else class="empty-block w-100" >
      <span>無查詢權限</span>
    </div>

    <div class="row float-right  mt-4">
      <button type="button" @click="backSearchList" class="btn btn-primary mt-0">回查詢列表</button>
    </div>
  </div>
</template>

<script>
import DataTable from '@/components/DataTable/DataTableCollapse'
import {commonMixin} from '@/mixins/common'

//mock data
import { getEffective } from '@/service'

export default {
  name: 'Effectiveness',
  mixins: [commonMixin],
  components: {
    DataTable
  },
  props: {
    status: {
      type: String,
      default: ''
    },
    effectData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  watch: {
    status(val) {  // 監聽 show 條件更新
      if(val == 'STATUS_EFFECTIVENESS'){
        this.breadcrumbs = []
        this.queryEffective('1', this.effectData.devno, this.effectData.cedvnm)
      }
    },
  },
  computed: {
    isBottom () {  // 計算是不是底層
      if(this.tableRow[0].click_agnt_list) {
        return true
      } else {
        return false
      } 
    },
  },
  data () {
    return {
      message_data: {
        agnt_id: "",
        agnt_name: "",
        applydate: "",
        cedvnm: "",
        devfilter_name: "",
        devfilter_serno: "",
        devno: "",
        end_date: "",
        field_name: "",
        foption: "",
        modifydate: "",
        option_ch: "",
        ta_count: 0,
        target_cs: "",
        upload_date: "",
      },
      breadcrumbs: [],
      tableRow: [],
      dataTree: {
        trace0: [],
        trace1: [],
        trace2: [],
      },
      header:[],
      permission: true,
      currentTableIndex: '1',
      effectivLoading: false,
    }
  },
  methods: {
    queryEffective (level, devno, divName) {  // 取得層級資料
      this.currentTableIndex = level
      this.effectivLoading = true
      getEffective(this.$store.state.userInfo.id, level, devno, this.effectData.devfilter_serno).then(result => {
        this.effectivLoading = false
        if (result.header && result.header.status == '200') {
          this.dataTree['trace' + level] = result.body.dev_list
          this.tableRow = []
          setTimeout(() => {
            this.tableRow = result.body.dev_list
            this.registerHanlink()  // for 難字update
          }, 50);
          if(this.currentTableIndex==0){
            this.breadcrumbs.push({name: '全部', index: level})
          }else{
            this.breadcrumbs.push({name: divName, index: level})
          }
          this.message_data = result.body.oneconditions[0]
        }
      })
    },
    gotoNext (item) {  // 往下一層
      let nextIndex = this.currentTableIndex * 1 + 1 + ''
      this.queryEffective(nextIndex, item.cedvno, item.cedvnm)
    },
    returnTable (bread, idx) {  // 回到上一層
      this.tableRow = [...this.dataTree['trace' + bread.index]]
      this.currentTableIndex = bread.index
      this.breadcrumbs = this.breadcrumbs.slice(0, idx + 1)
    },
    sumAngtCount (tableData) {  // 加總業務員數
      let numAry = tableData.map(item => {
        if(item.ta_count) {
          return Number(item.ta_count)
        } else {
          return 0
        }
      })
      return numAry.reduce((a,b)=>a+b)
    },
    sumUsedCount (tableData) {  // 加總使用率
      let numAry = tableData.map(item => {
        if(item.click_percentage) {
          return Number(item.click_percentage) * item.ta_count
        } else {
          return 0
        }
      })
      let agCount = tableData.map(item => {
        if(item.ta_count) {
          return Number(item.ta_count)
        } else {
          return 0
        }
      }).reduce((a,b)=>a+b)

      return (numAry.reduce((a,b)=>a+b) / agCount).toFixed(2)
    },
    backSearchList() {
      this.$emit('change-status','STATUS_SEARCH_LIST');
    },
  },
  mounted () {

  }
}
</script>